import ImageWithProductCarousel, { ImageWithProductCarouselProps } from './ImageWithProductCarousel'

export default ImageWithProductCarousel

export { ImageWithProductCarousel }
export type { ImageWithProductCarouselProps }
